import React, { Component } from 'react'
import './table.less'
interface iProps {
    children:React.ReactNode
}
export default class TableTitle extends Component<iProps> {
    render() {
        return (
            <div className="title">
                {this.props.children}            
            </div>
        )
    }
}
